import { useEffect, useRef } from 'react';

// What stopped a save, right under the form's action bar: an alert that takes
// focus when it appears, so a keyboard or screen reader user lands on it
// instead of on a dead Save button. One message reads as a line, several as a
// list. Nothing when there is no error. Without `focusKey` it takes focus
// whenever its text changes. With one, only when the key changes: the caller
// builds it from the save-attempt counter and the server error text, so a
// summary that only shrinks while the user types (the last issue fixed) never
// pulls focus out of the field.
export function FormErrorSummary({ error, className = '', focusKey }: { error?: string | string[] | null; className?: string; focusKey?: string | number }) {
  const items = (Array.isArray(error) ? error : error ? [error] : []).filter(Boolean);
  const text = items.join('\n');
  const ref = useRef<HTMLDivElement | null>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (text) ref.current?.focus(); }, [focusKey ?? text]);
  if (!items.length) return null;
  return (
    <div
      ref={ref}
      role="alert"
      tabIndex={-1}
      className={`rounded-md border border-red-200 bg-red-50 px-2.5 py-1.5 text-[0.75rem] text-red-700 outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-red-400 ${className}`}
    >
      {items.length === 1 ? items[0] : (
        <ul className="list-disc pl-4 space-y-0.5">{items.map((m, i) => <li key={`${i}-${m}`}>{m}</li>)}</ul>
      )}
    </div>
  );
}
